// extracted by mini-css-extract-plugin
module.exports = {"card":"news_card___xk0z","areaBanner":"news_areaBanner__wGRLu","areaText":"news_areaText__3w58B","header":"news_header__2nU5B","areaButtons":"news_areaButtons__3RUc8"};